import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdvanceSalesEnabledGuard } from 'src/app/shared/services/advance-sales-enabled.guard';
import { AdvanceSalesComponent } from './advance-sales/advance-sales.component';
import { CashApiComponent } from './my-account/components/cash-api/cash-api.component';
import { ReferralsComponent } from './referrals/referrals.component';
import { SellerComponent } from './seller-dashboard/seller.component';
import { PermissionsGuardService } from 'src/app/shared/services/permissions-guard.service';


const sellerRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: SellerComponent,
    canActivate: [PermissionsGuardService],
  },
  {
    path: 'advanceSales',
    component: AdvanceSalesComponent,
    canActivate: [AdvanceSalesEnabledGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./payment-pages/payment-pages.module').then(
        (m) => m.PaymentPagesModule
      ),
  },
  {
    path: 'promo-code',
    loadChildren: () =>
      import('./promocode/promocode.module').then((m) => m.PromocodeModule),
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./report/report.module').then((m) => m.ReportModule),
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./my-account/my-account.module').then((m) => m.MyAccountModule),
  },
  {
    path: 'team',
    loadChildren: () => import('./team/team.module').then((m) => m.TeamModule),
  },
  {
    path: 'organization',
    loadChildren: () => import('./organization/organization.module').then((m) => m.OrganizationModule),
  },
  {
    path: 'financials',
    loadChildren: () =>
      import('./financials/financials.module').then((m) => m.FinancialsModule),
  },
  {
    path: 'referrals',
    component: ReferralsComponent,
  },
  {
    path: 'cash-api',
    component: CashApiComponent,
  },
  {
    path: 'billPayments',
    loadChildren: () =>
      import('./billing/bill.module').then((m) => m.BillerModule),
  },
  {
    path: 'customers',
    loadChildren: () => import('./customers/customers.module').then((m) => m.CustomersModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(sellerRoutes)],
  exports: [RouterModule],
})
export class SellerRoutingModule {}
